import { render } from "./nest_gallery.vue?vue&type=template&id=1f81b2ff"
import script from "./nest_gallery.vue?vue&type=script&lang=js"
export * from "./nest_gallery.vue?vue&type=script&lang=js"

import "./nest_gallery.vue?vue&type=style&index=0&id=1f81b2ff&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__